import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import deleteRoomSystemsMutation from 'queries/roomSystems/DeleteRoomSystemsMutation.gql';
import listRoomsQuery from 'queries/roomSystems/listRoomsQuery.gql';
import { ConfirmModal } from 'components/Modals/ConfirmModal/ConfirmModal';
import { RoomSystem } from 'typings/types';
// import { ApolloError } from 'apollo-client';

interface Props {
  closeModal: () => void;
  resetSelection: () => void;
  confirmTitle: string;
  confirmButtonText: string;
  errorMessage: string;
  uuid: string;
  serialNumber: string;
  selectionArray: string[];
}

export class DeleteRoomSystemsModal extends Component<Props> {
  render() {
    const {
      selectionArray,
      closeModal,
      confirmTitle,
      confirmButtonText,
      errorMessage,
      resetSelection
    } = this.props;
    return (
      <Mutation
        mutation={deleteRoomSystemsMutation}
        update={(cache, { data: { deleteRooms } }) => {
          // tslint:disable-next-line
          const response: any = cache.readQuery({
            query: listRoomsQuery
          });
          const directoryListRoomSystem = response.directoryListRoomSystem;
          const dataToWrite = directoryListRoomSystem.records.filter((r: RoomSystem) => {
            return !deleteRooms.find((room: RoomSystem) => {
              return room.serialNumber === r.serialNumber;
            });
          });
          directoryListRoomSystem.records = dataToWrite;

          cache.writeQuery({
            query: listRoomsQuery,
            data: { directoryListRoomSystem: directoryListRoomSystem }
          });
        }}
      >
        {(deleteRooms, { loading, error }) => (
          <ConfirmModal
            confirmTitle={confirmTitle}
            confirmButtonText={confirmButtonText}
            isBusy={loading}
            errorMessage={errorMessage}
            closeModal={closeModal}
            confirmAction={async () => {
              try {
                await deleteRooms({
                  variables: {
                    serialNumbers: selectionArray,
                  }
                });
                resetSelection();
                closeModal();
              } catch (e) {
                // console.log('error', e);
              }
            }}
          />
        )}
      </Mutation>
    );
  }

}

export default DeleteRoomSystemsModal;
